import { render } from "./PaymentPending.vue?vue&type=template&id=01025246&scoped=true"
import script from "./PaymentPending.vue?vue&type=script&lang=js"
export * from "./PaymentPending.vue?vue&type=script&lang=js"

import "./PaymentPending.vue?vue&type=style&index=0&id=01025246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01025246"]])

export default __exports__